import { getValidationMessage } from "../../utils/i18nHelper";
import { validationMessagesAdd } from "./linkLandingPageAddValidation";
import { validationMessagesUpdate } from "./linkLandingPageUpdateValidation";

const validUrlRegex = /^(?:https?|http):\/\/(?:[^\s\/]+\.)?[^\s\/]+\.[^\s\/]+(?:\/[^\/\s]*)*$/;

const platformValidUrls = {
  "instagram": "instagram.com",
  "facebook": "facebook.com",
  "twitter": "twitter.com",
  "linkedin": "linkedin.com",
  "tiktok": "tiktok.com",
  "youtube": "youtube.com",
  "other": "",
};

export const  getSocialPlatformValidators = (platformKey, lang, module) => {
  let validationMessages = module === "add" ? validationMessagesAdd : validationMessagesUpdate;
  let fieldName = `social_link_destination_url_${platformKey}`;
  if (platformKey !== "other") {
    let spValidators = {
      validators: {
        notEmpty: {
          message: getValidationMessage(validationMessages, fieldName, 'required', lang)
        },
        regexp: {
          regexp: validUrlRegex,
          message: getValidationMessage(validationMessages, fieldName, 'regexp', lang),
        },
        promise: {
          message: getValidationMessage(validationMessages, fieldName, 'invalid', lang),
          promise: function(input) {
            return new Promise(function(resolve, reject) {
              if(input.value !== "") {
                let destinationUrl = input.value;
                let validPlatformUrl = platformValidUrls[platformKey];
                let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                if(destinationUrl !== "other" && !socialUrlValid) {
                  resolve({ valid: false, message: getValidationMessage(validationMessages, fieldName, 'invalid', lang)});
                } else {
                  resolve({valid: true, message: ""});
                }
              }
              else {
                reject({valid: false, message: getValidationMessage(validationMessages, fieldName, 'invalid', lang)});
              }
            })
          }
        },
      }
    }
    return spValidators;
  } else {
    let fieldNameOther = `social_link_destination_url_other`;
    let spValidatorsOther = {
      validators: {
        regexp: {
          regexp: validUrlRegex,
          message: getValidationMessage(validationMessages, fieldNameOther, 'regexp', lang),
        },
      }
    }
    return spValidatorsOther;
  }
};


export const getDestinationUrlValidators = (lang, module) => {
  let validationMessages = module === "add" ? validationMessagesAdd : validationMessagesUpdate;
  let fieldName = "featured_link_destination_url";
  let destinationUrlValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, fieldName, 'required', lang)
      },
      regexp: {
        regexp: validUrlRegex,
        message: getValidationMessage(validationMessages, fieldName, 'regexp', lang),
      },
    }
  };
  return destinationUrlValidators;
};


export const getTitleValidators = (lang, module) => {
  let validationMessages = module === "add" ? validationMessagesAdd : validationMessagesUpdate;
  let fieldName = "featured_link_title";
  let titleValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, fieldName, 'required', lang)
      },
      stringLength: {
        min: 0,
        max: 100,
        message: getValidationMessage(validationMessages, fieldName, 'length', lang)
      },
    }
  };
  return titleValidators;
};